import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-fb-announcements-dashboard-card',
  templateUrl: './fb-announcements-dashboard-card.component.html',
  styleUrls: ['./fb-announcements-dashboard-card.component.scss']
})
export class FbAnnouncementsDashboardCardComponent implements OnInit {
  @Input() content: {
    type: string,
    title: string,
    footerLink: string
  };
  annoucementList = [];

  constructor() { }

  ngOnInit() {
    this.annoucementList = [
      {
        title: 'Appraisal For UX Team',
        datatime: '16 SEP 2023 03:30 PM',
        message: 'Check your inboxes for the appointed time for your upcoming team meeting scheduled for next week.'
      },
      {
        title: 'Mail servers are out of service',
        datatime: '10 SEP 2023 04:30 PM',
        message: 'We are experiencing issues with our mail servers. Please be patient as we work to resolve the problem.'
      },
      {
        title: 'Quarterly Financial Review',
        datatime: '20 SEP 2023 02:00 PM',
        message: 'Join us for the quarterly financial review. The meeting link will be shared soon.'
      },
      {
        title: 'Maintenance Downtime',
        datatime: '25 SEP 2023 01:00 AM',
        message: 'Our platform will undergo maintenance. Expect about 2 hours of downtime.'
      },
      // {
      //   title: 'New Employee Onboarding',
      //   datatime: '18 SEP 2023 10:00 AM',
      //   message: 'Welcome our new team members. Join the onboarding session to greet them.'
      // },
      // {
      //   title: 'Cybersecurity Training',
      //   datatime: '22 SEP 2023 11:00 AM',
      //   message: 'Mandatory cybersecurity training for all employees. Ensure you attend.'
      // },
      // {
      //   title: 'Office Reopening Guidelines',
      //   datatime: '19 SEP 2023 03:00 PM',
      //   message: 'Review the guidelines for the phased reopening of our office spaces.'
      // },
      // {
      //   title: 'Product Launch Debrief',
      //   datatime: '24 SEP 2023 04:00 PM',
      //   message: 'Join the debrief session post our recent product launch. Feedback is welcome.'
      // },
      // {
      //   title: 'Health and Wellness Webinar',
      //   datatime: '26 SEP 2023 05:00 PM',
      //   message: 'Sign up for our health and wellness webinar. Limited slots available.'
      // },
      // {
      //   title: 'Software Update Notice',
      //   datatime: '28 SEP 2023 12:00 PM',
      //   message: 'A new software update will be rolled out. Check the documentation for changes.'
      // },
      // {
      //   title: 'Client Feedback Session',
      //   datatime: '30 SEP 2023 03:00 PM',
      //   message: 'Join the session to hear feedback from our top clients. Your participation is crucial.'
      // },
      // {
      //   title: 'Year-end Party Planning',
      //   datatime: '02 OCT 2023 02:00 PM',
      //   message: 'Be a part of the year-end party planning committee. Share your ideas!'
      // },
      // {
      //   title: 'Data Privacy Training',
      //   datatime: '04 OCT 2023 11:00 AM',
      //   message: 'Attend the data privacy training to understand our updated policies.'
      // },
      // {
      //   title: 'Team Building Activity',
      //   datatime: '06 OCT 2023 01:00 PM',
      //   message: 'Join us for a fun team-building activity. Let’s strengthen our bonds!'
      // },
      // {
      //   title: 'Server Upgrade Notice',
      //   datatime: '08 OCT 2023 12:00 AM',
      //   message: 'Our servers will be upgraded. Expect minimal disruptions.'
      // },
      // {
      //   title: 'Feedback on New Tools',
      //   datatime: '10 OCT 2023 03:00 PM',
      //   message: 'Share your feedback on the new tools we’ve introduced last month.'
      // },
      // {
      //   title: 'Holiday Schedule Announcement',
      //   datatime: '12 OCT 2023 10:00 AM',
      //   message: 'Review the holiday schedule for the upcoming festive season.'
      // },
      // {
      //   title: 'Leadership Talk Series',
      //   datatime: '14 OCT 2023 04:00 PM',
      //   message: 'Join the leadership talk series. This month’s guest is a renowned industry expert.'
      // },
      // {
      //   title: 'Employee Benefits Review',
      //   datatime: '16 OCT 2023 02:00 PM',
      //   message: 'Understand the changes to our employee benefits program. Your feedback is valued.'
      // },
      // {
      //   title: 'Project Milestone Celebration',
      //   datatime: '18 OCT 2023 05:00 PM',
      //   message: 'Celebrate our project milestones. Your hard work has paid off!'
      // }
    ];
  }

}
